import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {  FaChevronDown, FaChevronUp } from "react-icons/fa";
import TrendingProducts from "components/dashboardComponents/trendingProducts";
import useGetCataloguesWithAllItem from "hook/useGetCataloguesWithAllItem";
import { Range, getTrackBackground } from "react-range";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OrderNowModal from "models/orderNowModal";
import CardDesign from "components/cardDesign";
import { CatalogueWiseDataShimmer } from "components/shimmer/catalogueWiseDataShimmer";
import FooterSection from "assets/Footer";
import ScrollToTopButton from "components/ScrollToTopButton";
import { useSettings } from "context/SettingsContext";
import { t } from "context/translations";
const CategoryWiseData = () => {
  const STEP = 1;
  const MIN = 100;
  const MAX = 20000;
  const [selectedSubs, setSelectedSubs] = useState([]);
  const [itemsToShow, setItemsToShow] = useState([]);
  const [openCategory, setOpenCategory] = useState(true);
  const [openBrand, setOpenBrand] = useState(true);
  const [sort, setSort] = useState("latest");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const { catalogueId } = useParams();
  const { subGroupedAllData, loading, error } =
    useGetCataloguesWithAllItem(catalogueId);
  const [values, setValues] = useState([100, 20000]);
  const [orderModalOpen, setOrderModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const { theme, language } = useSettings();
  const isDark = theme === "dark";

  useEffect(() => {
    if (!subGroupedAllData || subGroupedAllData.length === 0) return;

    const catalogue = subGroupedAllData[0];
    const allItems = catalogue?.items || [];

    let resultItems = [];

    // ✅ Filter by selected subCatalogue
    if (selectedSubs.length === 0) {
      resultItems = allItems;
    } else {
      resultItems = allItems.filter((item) =>
        selectedSubs.includes(item.subCatalogue),
      );
    }

    // ✅ Price Range Filter
    const isDefaultRange = values[0] === MIN && values[1] === MAX;

    if (!isDefaultRange) {
      resultItems = resultItems.filter((item) => {
        const price = getItemPrice(item);
        return price >= values[0] && price <= values[1];
      });
    }

    // ✅ Sorting
    if (sort === "price_low") {
      resultItems.sort((a, b) => getItemPrice(a) - getItemPrice(b));
    } else if (sort === "price_high") {
      resultItems.sort((a, b) => getItemPrice(b) - getItemPrice(a));
    }

    setItemsToShow(resultItems);
  }, [subGroupedAllData, selectedSubs, values, sort]);

  const subCatalogues = subGroupedAllData[0]?.subcatalogues || [];

  const handleSubChange = (subId) => {
    setSelectedSubs((prev) =>
      prev.includes(subId)
        ? prev.filter((id) => id !== subId)
        : [...prev, subId],
    );
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getItemPrice = (item) => {
    const firstVariant = item.variants?.[0];
    return firstVariant?.flashPrice || 0;
  };

  if (loading) {
    return <CatalogueWiseDataShimmer />;
  }

  return (
    <div className={`${isDark?"bg-gray-100":"bg-white"}  select-none`}>
      <div
        className={`flex mt-2 md:gap-5 gap-0 ${isMobile ? "flex-col" : "flex-row"}`}
      >
        {/* Sidebar */}
        <aside
          className={`${isDark?"bg-gray-100":"bg-white"} rounded-xl shadow-md p-4 
  ${isMobile ? "hidden" : "w-1/4"}`}
        >
          <h3 className="text-md text-center bg-lightBgColor text-darkBgColor font-semibold py-1 mb-3">
            {t("filter", language)}
          </h3>

          {/* Categories */}
          <div className="border-b border-gray-200 pb-2 mb-2">
            <div
              className="flex justify-between items-center cursor-pointer font-medium"
              onClick={() => setOpenCategory(!openCategory)}
            >
              <span>{t("subCategories", language)}</span>
              {openCategory ? <FaChevronUp /> : <FaChevronDown />}
            </div>
            {openCategory && (
              <div className="mt-2 flex flex-col gap-1 text-sm bg-[#F1F5F9] p-2 text-gray-600 rounded">
                {subCatalogues.map((sub) => (
                  <label
                    key={sub.subCatalogue_id}
                    className="flex items-center gap-2"
                  >
                    <input
                      type="checkbox"
                      checked={selectedSubs.includes(sub.subCatalogue_id)}
                      onChange={() => handleSubChange(sub.subCatalogue_id)}
                      className="accent-indigo-600"
                    />
                    {sub.title} ({sub.total_products})
                  </label>
                ))}
              </div>
            )}
          </div>

          {/* Price Filter */}
          <div className="border-b border-gray-200 pb-2 mb-2">
            <div
              className="flex justify-between items-center cursor-pointer font-medium"
              onClick={() => setOpenBrand(!openBrand)}
            >
              <span>{t("priceRange", language)}</span>
              {openBrand ? <FaChevronUp /> : <FaChevronDown />}
            </div>
            {openBrand && (
              <div className="mt-2 flex flex-col gap-1 text-sm bg-[#F1F5F9] p-2 text-gray-600 rounded">
                <div className="px-2">
                  <Range
                    values={values}
                    step={STEP}
                    min={MIN}
                    max={MAX}
                    onChange={(values) => setValues(values)}
                    renderTrack={({ props, children }) => (
                      <div
                        onMouseDown={props.onMouseDown}
                        onTouchStart={props.onTouchStart}
                        style={{
                          ...props.style,
                          height: "36px",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div
                          ref={props.ref}
                          style={{
                            height: "6px",
                            width: "100%",
                            borderRadius: "4px",
                            background: getTrackBackground({
                              values,
                              colors: ["#ccc", "#4CAF50", "#ccc"],
                              min: MIN,
                              max: MAX,
                            }),
                            alignSelf: "center",
                          }}
                        >
                          {children}
                        </div>
                      </div>
                    )}
                    renderThumb={({ props, index }) => (
                      <div
                        {...props}
                        style={{
                          ...props.style,
                          height: "20px",
                          width: "20px",
                          borderRadius: "50%",
                          backgroundColor: "#FFF",
                          border: "2px solid #4CAF50",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                        }}
                      >

                      </div>
                    )}
                  />
                  <p>
                    {t("selectedRange", language)}: <b>{values[0]}</b> - <b>{values[1]}</b>
                  </p>
                </div>
              </div>
            )}
          </div>
        </aside>
        {isMobile && (
          <div className=" px-4 flex justify-between items-center mt-1">
            <div className="flex flex-col">
              <span className="text-lg font-bold bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 bg-clip-text text-transparent">
                {subGroupedAllData[0]?.title || ""}
              </span>
              <span className="text-sm text-gray-500">
                {itemsToShow.length} {t("itemsFound", language)}
              </span>
            </div>

            {/* 🔥 Mobile Filter Button */}

            <button
              onClick={() => setIsFilterOpen(true)}
              className="flex text-sm items-center gap-2 py-2 font-bold  "
            >
              ☰ {t("filter", language)}
            </button>
          </div>
        )}
        {/* Products Section */}
        <main className="flex-1">
          <div className="pb-20">
            {!isMobile && (
              <div className="mb-4 px-3 flex justify-between items-center">
                <div className="flex flex-col">
                  <span className="font-semibold bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 bg-clip-text text-transparent">
                    {subGroupedAllData[0]?.title || ""}
                  </span>
                  <span className="text-sm text-gray-500">
                    {itemsToShow.length} {t("itemsFound", language)}
                  </span>
                </div>
                <select
                  value={sort}
                  onChange={(e) => setSort(e.target.value)}
                  className="border border-darkBgColor rounded-md px-3 py-2"
                >
                  <option value="latest">{t("latest", language)}</option>
                  <option value="price_low">{t("priceLowToHigh", language)}</option>
                  <option value="price_high">{t("priceHighToLow", language)}</option>
                </select>
              </div>
            )}
            <CardDesign
              likeData={itemsToShow}
              loading={loading}
              error={error}
            />
          </div>
        </main>
      </div>
      {isMobile && isFilterOpen && (
        <div className="fixed inset-0 z-50 flex">
          {/* Overlay */}
          <div
            className="absolute inset-0 bg-black/40"
            onClick={() => setIsFilterOpen(false)}
          />

          {/* Drawer */}
          <div className="relative w-3/4 max-w-xs bg-white h-full shadow-lg p-4 overflow-y-auto animate-slideIn">
            <div className="mb-4 pb-1">
              <div className="flex justify-between items-center">
                <h3 className="font-bold text-lg">{t("filter", language)}</h3>
                <button onClick={() => setIsFilterOpen(false)}>
                  <span className="text-red-600">✕</span>
                </button>
              </div>

              {/* Gradient Border */}
              <div className="h-[2px] w-full mt-1 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500"></div>
            </div>

            {/* 🔥 Reuse your filter content */}
            {/* Categories */}
            <div className="border-b border-gray-200 pb-2 mb-2">
              <div
                className="flex justify-between items-center cursor-pointer font-medium"
                onClick={() => setOpenCategory(!openCategory)}
              >
                <span className="font-semibold text-gray-600">
                  {t("subCategories", language)}
                </span>
              </div>

              {openCategory && (
                <div className="mt-2 flex flex-col gap-1 text-sm bg-[#F1F5F9] p-2 text-gray-600 rounded">
                  {subCatalogues.map((sub) => (
                    <label key={sub.subCatalogue_id} className="flex gap-2">
                      <input
                        type="checkbox"
                        checked={selectedSubs.includes(sub.subCatalogue_id)}
                        onChange={() => handleSubChange(sub.subCatalogue_id)}
                      />
                      {sub.title} ({sub.total_products})
                    </label>
                  ))}
                </div>
              )}
            </div>

            {/* Price Filter */}
            <div className="mt-3">
              <div className="border-b border-gray-200 pb-2 mb-2">
                <div
                  className="flex font-semibold text-gray-600 justify-between items-center cursor-pointer"
                  onClick={() => setOpenBrand(!openBrand)}
                >
                  <span className="">{t("priceRange", language)}</span>
                  {openBrand ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {openBrand && (
                  <div className="mt-2 flex flex-col gap-1 text-sm bg-[#F1F5F9] p-2 text-gray-600 rounded">
                    <div className="px-2">
                      <Range
                        values={values}
                        step={STEP}
                        min={MIN}
                        max={MAX}
                        onChange={(values) => setValues(values)}
                        renderTrack={({ props, children }) => (
                          <div
                            onMouseDown={props.onMouseDown}
                            onTouchStart={props.onTouchStart}
                            style={{
                              ...props.style,
                              height: "36px",
                              display: "flex",
                              width: "100%",
                            }}
                          >
                            <div
                              ref={props.ref}
                              style={{
                                height: "6px",
                                width: "100%",
                                borderRadius: "4px",
                                background: getTrackBackground({
                                  values,
                                  colors: ["#ccc", "#4CAF50", "#ccc"],
                                  min: MIN,
                                  max: MAX,
                                }),
                                alignSelf: "center",
                              }}
                            >
                              {children}
                            </div>
                          </div>
                        )}
                        renderThumb={({ props, index }) => (
                          <div
                            {...props}
                            style={{
                              ...props.style,
                              height: "20px",
                              width: "20px",
                              borderRadius: "50%",
                              backgroundColor: "#FFF",
                              border: "2px solid #4CAF50",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                            }}
                          >
                          </div>
                        )}
                      />
                      <p>
                        {t("selectedRange", language)}: <b>{values[0]}</b> - <b>{values[1]}</b>
                      </p>
                    </div>
                  </div>
                )}
              </div>
              <div className="mt-2">
                <select
                  value={sort}
                  onChange={(e) => setSort(e.target.value)}
                  className="border border-darkBgColor rounded-md px-3 py-2"
                >
                  <option value="latest">{t("latest", language)}</option>
                  <option value="price_low">{t("priceLowToHigh", language)}</option>
                  <option value="price_high">{t("priceHighToLow", language)}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      )}
      <OrderNowModal
        isOpen={orderModalOpen}
        item={selectedItem}
        onClose={() => setOrderModalOpen(false)}
      />
      <ScrollToTopButton />
      <TrendingProducts />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {/*<FooterSection />*/}
    </div>
  );
};

export default CategoryWiseData;
